module.exports = __webpack_public_path__ + "media/images/category_icons/flash_card-3ca4f8d52088d3331e9fa4f017bd568f.svg";